import moment from "moment/moment";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetDoctorList,
  GetLocationList,
  GetOffers,
  GetSlots,
  GetSpecialityList,
  GetTimeSlots,
  GetDoctorEntity,
} from "../utils/Api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setBasicData, setConsultData } from "../Redux/Actions/Actions";
import SearchableDropdown from "../components/SearchableDropdown";
import OfferCard from "../components/OfferCard";

const apointmentTypes = [
  { id: "audio", name: "Audio" },
  { id: "video", name: "Video" },
  { id: "chat", name: "Chat" },
  { id: "clinic", name: "Clinic" },
  { id: "follow up", name: "Follow up" },
  { id: "home", name: "Home" },
  { id: "emergency", name: "Emergency" },
  { id: "rpm", name: "RPM" },
];

const AppointMent = () => {
  const navigate = useNavigate();
  const Dispacth = useDispatch();
  const Basic = useSelector((state) => state.Basic);
  const Const = useSelector((state) => state.Const);
  const startTime = moment("09:00 AM", "hh:mm A"); // Start time: 9:00 AM
  const endTime = moment("06:00 PM", "hh:mm A"); // End time: 6:00 PM
  const currentDate = moment();
  const [languuage, setLanguage] = useState("english");
  const [selectedDate, setSelectedDate] = useState("");
  const [slotToShow, setSlotToShow] = useState("");
  const [type, setType] = useState("audio");
  const [date, setDates] = useState([]);
  const [time, setTime] = useState([]);
  const [slot, setSlot] = useState("");
  const [slots, setSlots] = useState([]);
  const [timeSlot, setTimeSlot] = useState("");
  const [slotToFrom, setSlotToFrom] = useState([]);
  const [finalDate, setFinalDate] = useState("");
  const [isPayement, setIsPayement] = useState(false);

  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState("");
  const [sepciality, setSpeciality] = useState([]);

  const [masterDoctors, setMasterDoctors] = useState([]);
  const [masterLocations, setMasterLocations] = useState([]);
  const [masterSpeciality, setMasterSpeciality] = useState([]);

  const [availableDays, setAvailableDays] = useState([]);
  const [availableTypes, setAvailableTypes] = useState(apointmentTypes);
  const [selectedDoctorEntity, setSelectedDoctorEntity] = useState(null);

  const dateListRef = React.useRef(null);
  const isDraggingRef = React.useRef(false);
  const startXRef = React.useRef(0);
  const scrollLeftRef = React.useRef(0);
  const hasMovedRef = React.useRef(false);

  const handleMouseDown = (e) => {
    isDraggingRef.current = true;
    hasMovedRef.current = false;
    startXRef.current = e.pageX - (dateListRef.current?.offsetLeft || 0);
    scrollLeftRef.current = dateListRef.current?.scrollLeft || 0;
  };

  const handleMouseLeave = () => {
    isDraggingRef.current = false;
  };

  const handleMouseUp = () => {
    isDraggingRef.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDraggingRef.current || !dateListRef.current) return;
    const x = e.pageX - dateListRef.current.offsetLeft;
    const walk = (x - startXRef.current) * 1.5;
    if (Math.abs(walk) > 5) {
      hasMovedRef.current = true;
      dateListRef.current.scrollLeft = scrollLeftRef.current - walk;
    }
  };

  // 1. Initial mount master data fetching & Redux state restoration
  useEffect(() => {
    const fetchMasterData = async () => {
      let userid = Basic.id;
      if (!userid) return;

      try {
        const [doctorsRes, locationsRes, specialityRes] = await Promise.all([
          GetDoctorList(userid),
          GetLocationList(userid),
          GetSpecialityList()
        ]);

        let tempDocs = [];
        if (doctorsRes.status) {
          tempDocs = doctorsRes.data.map((item) => ({
            id: item.userID !== undefined ? item.userID : item.id,
            label: item.userFirstName || item.name || "",
          }));
          setMasterDoctors(tempDocs);
          setDoctors(tempDocs);
        } else {
          toast.error(doctorsRes.message);
        }

        let tempLocs = [];
        if (locationsRes.status) {
          tempLocs = locationsRes.data.map((item) => ({
            id: item.id,
            label: item.clinicAddress,
          }));
          setMasterLocations(tempLocs);
          setLocations(tempLocs);
        } else {
          toast.error(locationsRes.message);
        }

        let tempSpecs = [];
        if (specialityRes.status) {
          tempSpecs = specialityRes.data.map((item) => ({
            id: item.id,
            label: item.name,
          }));
          setMasterSpeciality(tempSpecs);
          setSpeciality(tempSpecs);
        } else {
          toast.error(specialityRes.message);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
        toast.error("Failed to load initial page data.");
      }
    };

    fetchMasterData();

    // Hydrate state from Redux cache if available
    if (Const.consultType != null) {
      setType(Const.consultType);
      setLanguage(Const.languages);
      setDates(Const.date);
      setTime(Const._timeArrey);
      setTimeSlot(Const._timeSlot);
      setSlots(Const._slotArrey);
      setSlot(Const._slot);
      setSlotToShow(Const.slotToShow);
      setSlotToFrom(Const.slotToFrom);
      setSelectedDoctor(Const.selectedDoctor);
      setSelectedAddress(Const.selectedAddress);
      setSelectedSpeciality(Const.selectedSpeciality);
    }
  }, [Basic.id]);

  // 2. Fetch time slots only when finalDate changes
  useEffect(() => {
    const fetchTimeSlots = async () => {
      if (!finalDate) return;
      try {
        const res = await GetTimeSlots(finalDate);
        const json = await res.json();
        setTime(json.data);
      } catch (error) {
        console.error("Error fetching time slots:", error);
      }
    };
    fetchTimeSlots();
  }, [finalDate]);

  // 3. Cascading filter logic based on selections
  useEffect(() => {
    const handleFilters = async () => {
      let userid = Basic.id;
      if (!userid) return;

      // Case A: Doctor is selected -> replace locations and specialities options
      if (selectedDoctor) {
        try {
          const res = await GetDoctorEntity(userid, selectedDoctor, "", "");
          if (res.status && res.data && res.data.length > 0) {
            const doc = res.data[0];
            setSelectedDoctorEntity(doc);
            
            // Extract and format locations
            const mappedLocs = doc.clinicAddress.map((element) => ({
              id: element.CId,
              label: element.clinicAddress || element.CName || "Unknown Address",
            }));
            setLocations(mappedLocs);

            // Extract and format specialities
            const mappedSpecs = doc.specialityList.map((element) => ({
              id: element.SpecialityID,
              label: element.Description || "Unknown Speciality",
            }));
            setSpeciality(mappedSpecs);
          }
        } catch (error) {
          console.error("Error updating dropdown options for selected doctor:", error);
        }
      }
      // Case B: Doctor is NOT selected, but Location or Speciality is selected -> filter everything
      else if (selectedAddress || selectedSpeciality) {
        setSelectedDoctorEntity(null);
        try {
          const res = await GetDoctorEntity(userid, "", selectedAddress, selectedSpeciality);
          if (res.status && res.data) {
            // Filter doctors dropdown
            const mappedDocs = res.data.map((doc) => ({
              id: doc.userID !== undefined ? doc.userID : doc.id,
              label: doc.userFirstName || doc.name || "",
            }));
            setDoctors(mappedDocs);

            // Filter locations dropdown to unique locations from returned doctors
            const uniqueLocs = [];
            const seenLocs = new Set();
            res.data.forEach((doc) => {
              doc.clinicAddress.forEach((loc) => {
                if (!seenLocs.has(loc.CId)) {
                  seenLocs.add(loc.CId);
                  uniqueLocs.push({
                    id: loc.CId,
                    label: loc.clinicAddress || loc.CName || "Unknown Address",
                  });
                }
              });
            });
            setLocations(uniqueLocs);

            // Filter specialities dropdown to unique specialities from returned doctors
            const uniqueSpecs = [];
            const seenSpecs = new Set();
            res.data.forEach((doc) => {
              doc.specialityList.forEach((spec) => {
                if (!seenSpecs.has(spec.SpecialityID)) {
                  seenSpecs.add(spec.SpecialityID);
                  uniqueSpecs.push({
                    id: spec.SpecialityID,
                    label: spec.Description || "Unknown Speciality",
                  });
                }
              });
            });
            setSpeciality(uniqueSpecs);
          }
        } catch (error) {
          console.error("Error filtering dropdowns:", error);
        }
      }
      // Case C: No selections -> restore all master datasets
      else {
        setSelectedDoctorEntity(null);
        setDoctors(masterDoctors);
        setLocations(masterLocations);
        setSpeciality(masterSpeciality);
      }
    };

    handleFilters();
  }, [selectedDoctor, selectedAddress, selectedSpeciality, masterDoctors, masterLocations, masterSpeciality, Basic.id]);

  // 4. Validate doctor availability constraints (days & types) when doctor entity or selections change
  useEffect(() => {
    if (!selectedDoctorEntity) {
      setAvailableDays([]);
      setAvailableTypes(apointmentTypes);
      return;
    }

    const doc = selectedDoctorEntity;

    // 1. Validate available days
    const days = doc.availableDays ? doc.availableDays.map(d => d.DayDesc) : [];
    setAvailableDays(days);

    if (days.length > 0) {
      const currentSelectedDateObj = date.find(d => d.finaldate === finalDate);
      const isCurrentValid = currentSelectedDateObj && days.includes(currentSelectedDateObj.day);

      if (!isCurrentValid) {
        const firstValidDate = date.find(d => days.includes(d.day));
        if (firstValidDate) {
          setFinalDate(firstValidDate.finaldate);
          setSelectedDate(firstValidDate);
          setDates(prevDates =>
            prevDates.map(d => ({ ...d, isActive: d.id === firstValidDate.id }))
          );
          setTimeSlot("");
          setSlot("");
          setSlotToShow("");
          setSlotToFrom([]);
        } else {
          setFinalDate("");
          setSelectedDate("");
          setDates(prevDates => prevDates.map(d => ({ ...d, isActive: false })));
        }
      }
    }

    // 2. Validate available types (availabeInTypes)
    if (doc.availabeInTypes) {
      const types = doc.availabeInTypes.map(t => {
        const typeId = t.ServiceType.toLowerCase();
        const matched = apointmentTypes.find(a => a.id === typeId);
        return matched || { id: typeId, name: t.ServiceType };
      });
      setAvailableTypes(types);

      const isTypeAllowed = types.some(t => t.id === type);
      if (!isTypeAllowed && types.length > 0) {
        setType(types[0].id);
        toast.info(`Switched consultation type to ${types[0].name} for this doctor.`);
      }
    } else {
      setAvailableTypes(apointmentTypes);
    }
  }, [selectedDoctorEntity, finalDate, date, type]);
  useLayoutEffect(() => {
    let currentTime = startTime.clone();
    let temp = [];
    let tempSlots = [];
    for (let i = 0; i < 15; i++) {
      const nextDate = currentDate.clone().add(i, "days");
      const dayName = nextDate.format("dddd");
      const date = nextDate.format("D");
      temp.push({
        id: i,
        date,
        day: dayName,
        finaldate: nextDate.format("yyyy-MM-DD"),
        isActive: false,
      });
    }
    let id = 0;
    while (currentTime.isBefore(endTime)) {
      const fromTime = currentTime.format("hh:mm A");
      currentTime.add(30, "minutes");
      const toTime = currentTime.format("hh:mm A");
      tempSlots.push({
        id: id,
        time: `${fromTime} to ${toTime}`,
        isActive: false,
      });
      id++;
    }
    setTime(tempSlots);
    setDates(temp);
  }, []);

  useLayoutEffect(() => {
    if (type != "" && type != null && timeSlot != "" && timeSlot != null) {
      GetAponitmentSlot();
    }
  }, [type, timeSlot]);

  const GetAponitmentSlot = async () => {
    await GetSlots(type, timeSlot, finalDate).then((d) =>
      d.json().then((data) => {
        if (data.status == true) {
          setSlots(data.data);
        }
      })
    );
  };

  const GetIn24 = (time) => {
    return moment(time, "hh:mm A").format("HH:mm");
  };
  const handleContinue = () => {
    if (finalDate == "") {
      toast.warning("Please select a date.");
      return;
    }
    // const normalHeader = {
    //   "Content-Type": "application/json",
    //   device: "Android",
    //   Accept: "application/json",
    //   CorrelationId: 1234551516516565,
    //   AuthToken: Basic.authToken,
    //   userId: Basic.id,
    // };
    // let data = {
    //   guestId: Basic.id,
    //   consultType: type,
    //   consultationDate: finalDate,
    //   slot: slot,
    //   FromTime: GetIn24(slotToFrom[0]),
    //   ToTime: GetIn24(slotToFrom[1]),
    //   languages: languuage,
    //   userType: Basic.type,
    //   DoctorId: "-1",
    //   helpQuestion1: Basic.qs,
    //   AppointmentReqID: Basic.appReqId,
    // };
    let forCaching = {
      consultType: type,
      date: date,
      finalDate,
      languages: languuage,
      slotToShow: slotToShow,
      _timeSlot: timeSlot,
      _timeArrey: time,
      _slot: slot,
      _slotArrey: slots,
      slotToShow,
      slotToFrom,
      selectedDoctor: selectedDoctor,
      selectedAddress: selectedAddress,
      selectedSpeciality: selectedSpeciality,
    };
    Dispacth(setConsultData(forCaching));
    navigate("/doctor-selection");
    // PostApointMent(normalHeader, data).then((r) =>
    //   r.json().then((d) => {
    //     if (d.status) {
    //       let tempBasic = Basic;
    //       tempBasic.appReqId = d.appReqId;
    //       Dispacth(setBasicData(tempBasic));
    //       setIsPayement(true);
    //     }
    //   })
    // );
  };
  const HandlePayment = () => {
    navigate("/payement-page");
  };
  const handlelanguage = (value) => {
    setLanguage(value);
  };
  const handleDate = (value) => {
    let temp = [];
    setFinalDate(value.finaldate);
    setTimeSlot("");
    setSlot("");
    setSlotToShow("");
    setSlotToFrom([]);
    setIsPayement(false);
    Dispacth(setConsultData({}));
    for (let i = 0; i < date.length; i++) {
      const d = date[i];
      if (value.id == d.id) {
        setSelectedDate(d);
        d.isActive = true;
        temp.push(d);
      } else {
        d.isActive = false;
        temp.push(d);
      }
    }

    setDates(temp);
  };
  const handleType = (value) => {
    setType(value);
  };
  const handleSlot = (value, toFrom, index) => {
    setSlot(value);
    setSlotToShow(toFrom);
    let toFroms = toFrom.split("-");
    setSlotToFrom(toFroms);
  };

  return (
    <div className="container h-screen max-w-md mx-auto p-8 text-thtext">
      {/* <h1 className="text-2xl font-bold mb-4">
        Take a doctor consultation call
      </h1>
      <p>Doctors are available within the next few minutes</p> */}
      <div className="h-3/4 flex flex-col justify-between w-full">
        <div>
          <div>
            <h1 className=" text-sm mt-0">Select language</h1>
            <div className="flex mt-2">
              <div
                onClick={() => {
                  handlelanguage("english");
                }}
                className={`rounded-full ${
                  languuage == "english"
                    ? "bg-primary text-white"
                    : "bg-gray-200 border border-gray-300 text-gray-400"
                } px-8 py-1 cursor-pointer`}
              >
                <h1 className=" text-sm">English</h1>
              </div>
              <div
                onClick={() => {
                  handlelanguage("hindi");
                }}
                className={`rounded-full ${
                  languuage == "hindi"
                    ? "bg-primary text-white"
                    : "bg-gray-200 border border-gray-300  text-gray-400"
                } px-8 py-1 ml-4 cursor-pointer`}
              >
                <h1 className=" text-sm">Hindi</h1>
              </div>
            </div>
            <div className="flex justify-between items-center mt-4">
              <h1 className="text-sm">Select Doctor</h1>
              {(selectedDoctor || selectedAddress || selectedSpeciality) && (
                <button
                  type="button"
                  onClick={() => {
                    setSelectedDoctor("");
                    setSelectedAddress("");
                    setSelectedSpeciality("");
                  }}
                  className="text-xs text-red-500 hover:text-red-700 font-semibold transition-colors"
                >
                  Clear Filters
                </button>
              )}
            </div>
            <SearchableDropdown
              options={doctors}
              selected={selectedDoctor}
              onSelect={setSelectedDoctor}
              placeholder="Select Doctor"
            />
            <h1 className="text-sm mt-4">Select Location</h1>
            <SearchableDropdown
              options={locations}
              selected={selectedAddress}
              onSelect={setSelectedAddress}
              placeholder="Select Location"
            />
            <h1 className="text-sm mt-4">Select Specialty</h1>
            <SearchableDropdown
              options={sepciality}
              selected={selectedSpeciality}
              onSelect={setSelectedSpeciality}
              placeholder="Select Specialty"
            />
            <h1 className="text-sm mt-4">Select Date</h1>
            <div
              ref={dateListRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
              style={{ WebkitOverflowScrolling: "touch", touchAction: "pan-x" }}
              className="flex w-full overflow-x-auto py-1 touch-pan-x select-none cursor-grab active:cursor-grabbing"
            >
              {(() => {
                const firstAvailableIdx = date.findIndex(
                  (d) => !(availableDays.length > 0 && !availableDays.includes(d.day))
                );
                return date.map((value, index) => {
                  const disabled = availableDays.length > 0 && !availableDays.includes(value.day);
                  const autoSelect = index === firstAvailableIdx;
                  return (
                    <DateModal
                      key={index}
                      value={value}
                      handleDate={handleDate}
                      Date={date}
                      Const={Const}
                      disabled={disabled}
                      autoSelect={autoSelect}
                      hasMovedRef={hasMovedRef}
                    />
                  );
                });
              })()}
            </div>

            {/* <h1 className="text-sm mt-4">Select Time</h1>
                <div className="flex w-full overflow-auto">
                  {time.map((value, index) => (
                  <TimeModal
                    key={index}
                    value={value}
                    setTimeSlot={setTimeSlot}
                    Times={time}
                    timeSlot={timeSlot}
                  />
                  ))}
                </div> */}

            <h1 className="text-sm mt-4">Select type</h1>
            <div
              style={{ WebkitOverflowScrolling: "touch", touchAction: "pan-x" }}
              className="flex mt-2 overflow-x-auto w-full py-1 touch-pan-x select-none"
            >
              {availableTypes.map((value, index) => (
                <div
                  key={index}
                  onClick={() => {
                    handleType(value.id);
                  }}
                  className={`rounded-full shrink-0 ${
                    type == value.id
                      ? "bg-primary text-white"
                      : "bg-gray-200 border border-gray-300 text-gray-400"
                  } px-8 py-2 ml-2 cursor-pointer flex items-center justify-center`}
                >
                  <h1 className=" text-sm">{value.name}</h1>
                </div>
              ))}
            </div>
            {/* <h1 className="text-sm mt-4">Appointment slot</h1>
            <div className="flex w-full overflow-scroll">
              {slots.map((value, index) => {
                return (
                  <div
                    onClick={() => {
                      handleSlot(value.slot, value.slotDesc, index);
                    }}
                    key={index}
                    className={`${
                      value.slot == slot
                        ? "bg-primary text-white"
                        : "bg-gray-200 text-gray-400 border border-gray-300"
                    } rounded-2xl flex flex-col items-center justify-center py-2 px-2 mr-2 mt-2 cursor-pointer `}
                  >
                    <h1 className="text-sm text-center w-28">
                      {value.slotDesc}
                    </h1>
                  </div>
                );
              })}
            </div> */}
            <OfferCard />
          </div>
        </div>
        <div className="flex pr-8">
          <button
            className=" bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full mt-8"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
          <button
            className="bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full mt-8 ml-2"
            style={{ display: isPayement ? "none" : "flex" }}
            onClick={handleContinue}
          >
            Confirm
          </button>
          <button
            className="bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full mt-8 ml-2"
            style={{ display: !isPayement ? "none" : "flex" }}
            onClick={HandlePayment}
          >
            Make Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointMent;

function DateModal({ value, handleDate, Date, Const, disabled, autoSelect, hasMovedRef }) {
  useEffect(() => {
    if (Const.consultationDate == null && autoSelect) {
      handleDate(value);
    }
  }, [autoSelect]);
  return (
    <div
      onClick={() => {
        if (hasMovedRef && hasMovedRef.current) {
          hasMovedRef.current = false;
          return;
        }
        if (!disabled) {
          handleDate(value);
        } else {
          toast.warning("Selected date is not available for this doctor. Please pick an available date.");
        }
      }}
      className={`${
        disabled
          ? "bg-gray-100 text-gray-300 border border-gray-200 cursor-not-allowed opacity-50"
          : value.isActive
          ? "bg-primary text-white cursor-pointer"
          : "bg-gray-200 text-gray-400 border border-gray-300 cursor-pointer"
      } rounded-2xl flex flex-col items-center justify-center w-20 h-20 py-4 px-6 mr-2 mt-2 shrink-0 select-none`}
    >
      <h1 className="text-sm">{value.day.substring(0, 3).toUpperCase()}</h1>
      <h1 className="text-2xl">{value.date}</h1>
    </div>
  );
}
function TimeModal({ value, setTimeSlot, Times, timeSlot }) {
  useEffect(() => {
    setTimeSlot(Times[0].SlotDesc);
  }, []);
  return (
    <div
      onClick={() => {
        setTimeSlot(value.SlotDesc);
      }}
      className={`${
        value.SlotDesc == timeSlot
          ? "bg-primary text-white"
          : "bg-gray-200 text-gray-400 border border-gray-300 w-full"
      } rounded-2xl  flex flex-col items-center justify-center py-2 px-2 mr-2 mt-2 cursor-pointer`}
    >
      <h1 className="text-sm text-center w-28">{value.Slot}</h1>
    </div>
  );
}
